import ComingSoon from "@/components/ComingSoon";

export default function PatchingPage() {
  return <ComingSoon featureName="Patch Management" description="Manage macOS/iOS updates, create patch policies, and monitor compliance. This feature requires backend Patch Management APIs." />;
}
